import { css } from '@emotion/css';

export const rectPositionStyles = ({ top, left, width, height }: DOMRect) => css`
  top: ${top}px;
  left: ${left}px;
  width: ${width}px;
  height: ${height}px;
`;
